module.exports = "/images/descuento.svg";